(function () {
  'use strict';

  window.initDCV2 = function (sectionId) {
    const root = document.getElementById(`dc-v2-${sectionId}`);
    if (!root) return;

    const state = { expanded: false, leftIdx: 0, rightIdx: 1 };
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => root.querySelectorAll(s);

    updateActive(0, 1);
    syncSelectors();

    // Toggle
    $('.dc-v2-toggle-btn')?.addEventListener('click', () => {
      state.expanded = !state.expanded;
      root.classList.toggle('dc-v2--expanded', state.expanded);
      const btn = $('.dc-v2-toggle-btn');
      $('.dc-v2-toggle-text').textContent = state.expanded
        ? btn.dataset.collapseText
        : btn.dataset.expandText;
      if (!state.expanded && $('.dc-v2-header').getBoundingClientRect().bottom < 0) {
        $('.dc-v2-header').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Selectors — single delegated listener instead of binding each <select>
    root.addEventListener('change', (e) => {
      const sel = e.target.closest('.dc-v2-select');
      if (!sel) return;

      const newIdx = +sel.value;
      if (sel.dataset.position === 'left') {
        if (newIdx === state.rightIdx) return;
        state.leftIdx = newIdx;
      } else {
        if (newIdx === state.leftIdx) return;
        state.rightIdx = newIdx;
      }

      updateActive(state.leftIdx, state.rightIdx);

      const isSticky = sel.classList.contains('dc-v2-select--sticky');
      const mirror = isSticky ? ':not(.dc-v2-select--sticky)' : '.dc-v2-select--sticky';
      $$(`.dc-v2-select${mirror}`).forEach((s) => {
        s.value = s.dataset.position === 'left' ? state.leftIdx : state.rightIdx;
      });

      syncSelectors();
    });

    // Sticky header
    const header = $('.dc-v2-header');
    const sticky = $('.dc-v2-sticky');
    if (header && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('dc-v2-sticky--visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(header);

      new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) {
          sticky.classList.remove('dc-v2-sticky--visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      }).observe(root);
    }

    function updateActive(l, r) {
      state.leftIdx = l;
      state.rightIdx = r;
      $$('[data-product-idx]').forEach((col) => {
        const idx = +col.dataset.productIdx;
        col.classList.toggle('dc-v2-col--active', idx === l || idx === r);
        col.classList.toggle('dc-v2-col--left', idx === l);
        col.classList.toggle('dc-v2-col--right', idx === r);
      });
    }

    function syncSelectors() {
      $$('.dc-v2-select').forEach((sel) => {
        const otherIdx = sel.dataset.position === 'left' ? state.rightIdx : state.leftIdx;
        sel.querySelectorAll('option').forEach((opt) => {
          opt.hidden = +opt.value === otherIdx;
        });
      });
    }
  };
})();